$(function () {
  // Add smooth scrolling to all links
  $("a").on("click", function (event) {
    // Make sure this.hash has a value before overriding default behavior
    if (this.hash !== "") {
      // Prevent default anchor click behavior
      event.preventDefault();

      // Store hash
      var hash = this.hash;

      // Using jQuery's animate() method to add smooth page scroll
      // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
      $("html, body").animate(
        {
          scrollTop: $(hash).offset().top,
        },
        2000,
        function () {
          // Add hash (#) to URL when done scrolling (default click behavior)
          window.location.hash = hash;
        }
      );
    } // End if
  });

  $(".slider-hero-home").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    dots: true,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 6000,
  });

  $(".slider-year").slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: ".slider-desc",
    infinite: false,
    dots: false,
    arrows: false,
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });

  var windowWidth = $(window).width();

  $(".btn-slider-year-prev").on("click", function () {
    if (windowWidth > 767 && $(".slider-year .slick-track li").length < 5) {
      if ($(".slider-year .slick-track .slick-current").prev().length) {
        $(".slider-year .slick-track .slick-current")
          .removeClass("slick-current")
          .prev()
          .addClass("slick-current");
      }
    } else {
      $(".slider-year").slick("slickPrev");
    }
  });

  $(".btn-slider-year-next").on("click", function () {
    if (windowWidth > 767 && $(".slider-year .slick-track li").length < 5) {
      if ($(".slider-year .slick-track .slick-current").next().length) {
        $(".slider-year .slick-track .slick-current")
          .removeClass("slick-current")
          .next()
          .addClass("slick-current");
      }
    } else {
      $(".slider-year").slick("slickNext");
    }
  });

  $(".slider-desc").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    fade: true,
  });

  $(".js-download-pdf").on("click", function (e) {
    e.preventDefault();

    var imgs = [];
    $(".how-to__item .how-to__image").each(function (idx, el) {
      var imgUrl = $(el).attr("src");
      imgs.push(imgUrl);
    });

    async function addImageProcess(src) {
      return new Promise((resolve, reject) => {
        let img = new Image();
        img.src = src;
        img.onload = () => resolve(img);
        img.onerror = reject;
      });
    }

    async function generatePdf(imageUrls) {
      var doc = new jspdf.jsPDF();
      for (const [i, url] of imageUrls.entries()) {
        const image = await addImageProcess(url);
        doc.addImage(image, "JPEG", 0, 0, 210, 297);
        if (i !== imageUrls.length - 1) {
          doc.addPage();
        }
      }
      doc.save(
        $(
          "body > div > section.section.section__get-started.position-relative > div > div.row.mt-3.mb-5 > div > p"
        ).text() + ".pdf"
      );
    }

    generatePdf(imgs);
  });

  var $btnModalForm = $(".js-btn-modal-form");
  var $btnModalFormFloating = $(".js-floating-btn-modal-form");
  $btnModalFormFloating.hide();

  $(window).on("scroll", function (e) {
    var docHeight = $(document).height();
    var scrollTop = $(this).scrollTop();
    var scrollBottom = docHeight - ($(this).height() + $(this).scrollTop());

    var topPercentage = (scrollTop / docHeight) * 100;

    if (topPercentage <= 10) {
      $btnModalForm.fadeIn();
      $btnModalFormFloating.fadeOut();
    } else {
      $btnModalForm.fadeOut();
      $btnModalFormFloating.fadeIn();
    }
  });
});
